export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/logo_mathletics-872109e5a5d103cd7d96f68e27aa0ac4.svg";